export default values => ({
  rfc: values ? values.rfc : '',
  password: ''
});
